import { SwiperSlide } from "swiper/react";
import {
  CarouselStyled,
  LoaderContainer,
} from "../../../styles/Screens/CarouselStyled";
import { Text, Title } from "../../../styles/Texts";
import { CardSlide } from "./CardSlide";
import Swiper from "./Swiper";
import styled from "styled-components";
import RatingStars from "../../RatingStars";
import { useState, useEffect, useContext } from "react";
import axios from "axios";
import { DataContext } from "../../../contexts/DataContext";
import { PuffLoader } from "react-spinners";
import { T } from "../../../styles/Theme";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Button } from "../../Button";
import { PREDICT_API_URL, SERVICES_API_URL, ANSWERS_API_URL, HUBSPOT_KEYS, EMAIL_TO, ADVISER_IDENTIFIER, CONTACT_API_URL } from "../../../env";
import { AnswersContext } from "../../../contexts/AnswersContext";
import { parseAnswersDataHubspot } from "../../../utils/hubspot";
// import { recommendationGenerated, recommendedScreenLoaded, startAgain } from "../../../utils/googleAnalytics";
import { RecommendationGeneratedGTM, StartAgainGTM } from "../../../utils/GoogleTagManager";
import { getActivitiesToDo, getConectedDevicesAlternatives, getPlanSelected } from "../../../utils/common";
import { sendNotificationEmail } from "../../../utils/requests";

export const Carousel = () => {
  const [
    ,
    setFinalForm,
    ,
    setScreenNumber,
    ,
    ,
    ,
    ,
    ,
    setQuestionId,
    ,
    setCurrentPage,
  ] = useContext(DataContext);
  const [answers, setAnswers] = useContext(AnswersContext);

  const [data, setData] = useState<any[] | null>(null);
  const [length, setLength] = useState(1);
  // const [loading, setLoading] = useState(true);

  const [finalForm] = useContext(DataContext);

  const copyFinalForm: any[] = [];

  finalForm.forEach((el: any) => {
    const { id_question, answer } = el;
    copyFinalForm.push({ id_question, answer });
  });

  const post = {
    data: copyFinalForm,
  };

  useEffect(() => {
    const url = `${SERVICES_API_URL}/api/v1/services/`;
    RecommendationGeneratedGTM(window, answers.email, answers.phone, getPlanSelected(finalForm), getActivitiesToDo(finalForm), getConectedDevicesAlternatives(finalForm));

    axios
      .post(`${PREDICT_API_URL}/api/v1/predict/`, post, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        setLength(res.data.result.length);
        return res.data.result;
      })
      .then(async (result) => {
        const arrItems: Array<any> = [];

        for (const el of result) {
          const res = await axios.get(`${url}${el}/`);
          await arrItems.push(res.data);
          setData([...arrItems]);
        }
        const servicesToHubspot = parseServices([...arrItems]);
        const dataToHubspot = parseAnswersDataHubspot(answers.email, finalForm, servicesToHubspot, "", answers.phone);
        console.log(dataToHubspot);
        submitToHubspot(JSON.stringify(dataToHubspot));
      })
      .then(() => {
        // if (!window.sessionStorage.getItem("tryadviser-adviseGenerated")) {
        //   // recommendationGenerated();
        //   window.sessionStorage.setItem("tryadviser-adviseGenerated", "true");
        // }
        submitAnswers();
      });
  }, []);

  const parseServices = (dataEntry: Array<any>) => {
    const servicesRecommended = dataEntry.map((el: any) => el.name);
    return servicesRecommended;
  }

  const submitToHubspot = async (data: any) => {
    const config = {
      headers: {"Content-Type": "application/json"}
    };
    await axios.post(`https://api.hsforms.com/submissions/v3/integration/submit/${HUBSPOT_KEYS["portalId"]}/${HUBSPOT_KEYS["formId"]}`, data, config)
    .then((res) => {
      console.log(res);
    }).catch((err) => {
      console.log(err);
    });
  }

  const submitAnswers = async () => {
    const dataPost = {
      answers: {
        data: finalForm,
      },
      results: null,
    };
    const config = {
      headers: {
        "Content-Type": "application/json"
      }
    };

    // await axios.post(`${ANSWERS_API_URL}/api/v1/answers/`, dataPost, config)
    await axios.post(`${ANSWERS_API_URL}/${ADVISER_IDENTIFIER}/answers/`, dataPost, config)
      .then(async response => {
        if (response.status === 201) {
          setAnswers({...answers, idAnswer: response.data.id});
          if (answers.email) {
            const emailData = {
              answer_id: response.data.id,
              email: answers.email,
            }
            const contactData = JSON.stringify({
              answer_id: response.data.id,
              full_name: answers.name || null,
              phone: answers.phone,
              remark: null
            });
            // axios.post(`${ANSWERS_API_URL}/api/v1/answers-emails/`, emailData).then()
            await axios.post(`${ANSWERS_API_URL}/${ADVISER_IDENTIFIER}/answers/emails/`, emailData, config)
            await axios.post(`${CONTACT_API_URL}/${ADVISER_IDENTIFIER}/contacts/`, contactData, config)
          }
        }
      });
  }

  const submitSelectedService = async (item: any) => {
    const dataPost = {
      results: {
        data: [item],
      }
    };
    const config = {
      headers: {
        "Content-Type": "application/json"
      }
    };

    // await axios.put(`${ANSWERS_API_URL}/api/v1/answers/${answers.idAnswer}/`, dataPost, config)
    await axios.put(`${ANSWERS_API_URL}/${ADVISER_IDENTIFIER}/answers/${answers.idAnswer}/`, dataPost, config)
      .then(response => {
        if (response.status === 200) {
          console.log("updated!");
        }
      }).then(() => {
        const body = {
          email_to: EMAIL_TO,
          link: (item.links.length > 0) ? item.links[0].link : "",
          image: (item.images.length > 0) ? item.images[0].image_url : "",
          product_name: item.name,
          product_description: "",
          email: (answers.email) ? answers.email : "",
          data: finalForm
        }
        sendNotificationEmail(body).then((res) => {console.log("EMAIL HAS BEEN SENT", res.status)})
      })

      .catch(error => {
        console.log(error);
      });
  }

  return (
    <CarouselStyled>
      {data ? (
        <div className="header">
          <TitleStyled>
            Te recomendamos {length} {length === 1 ? "plan" : "planes"}
          </TitleStyled>
          <TextStyled>Desliza para comparar las distintas opciones</TextStyled>
        </div>
      ) : (
        <div className="headerSkeleton">
          <Title>
            <Skeleton />
          </Title>
          <TextStyled>
            <Skeleton />
          </TextStyled>
        </div>
      )}

      {data ? (
        <Swiper>
          {data.map((item, i) => {
            return (
              <SwiperSlide key={i}>
                <CardSlide
                  data={item}
                  onSelectService={() => submitSelectedService(item)}
                />
              </SwiperSlide>
            );
          })}
        </Swiper>
      ) : (
        <>
          <LoaderContainer>
            <PuffLoader color={T.green} size={130} />
            {/* <Text>Generando Recomendación</Text> */}
          </LoaderContainer>
        </>
      )}

      {data && (
        <>
          <RatingStars />
          <div className="buttonContainer">
            <Button
              bg={T.blue}
              c="white"
              onClick={() => {
                setScreenNumber(0);
                setCurrentPage(0);
                setQuestionId(1);
                setFinalForm([]);
                StartAgainGTM(window, answers.email, answers.phone, getPlanSelected(finalForm), getActivitiesToDo(finalForm), getConectedDevicesAlternatives(finalForm))
              }}
            >
              Volver a empezar
            </Button>
          </div>
        </>
      )}
    </CarouselStyled>
  );
};

const TitleStyled = styled(Title)`
  margin: 30px 0 5px 0;
`;

const TextStyled = styled(Text)`
  padding: 0 20px 0px 20px;
`;
